import { isReducedMotionPreferred } from "@helpers/reducedMotion";

export const VERIFICATION_CODE_LENGTH = 6;
export const DEFAULT_ICON_COLOR = "#D9DDE2";
export const isReducedMotionEnabled = isReducedMotionPreferred();

export const HEADER_HEIGHT = 48;

export const GUSTO_PREVIEW_URL = "/images/features/gusto.png";
export const TYPEFORM_OPENING_BALANCES_URL_BASE =
    "https://kickapp.typeform.com/to/aBDajEWN";

export const SEARCH_DEBOUNCE_TIME = 500;
export const ACTIVE_USER_ID_KEY = "active-user-id";

export const RELAY_PREVIEW_URL = "/images/relay_preview.png";
export const RELAY_URL =
    "https://relay.sjv.io/c/6170899/3010324/28490?referralcode=kick&utm_source=partnerships";

// Row heights (px) per view density — used by ViewTable and any component
// that needs to compute how many rows fit in the viewport.
export const DENSITY_ROW_HEIGHT = {
    sm: 64,
    md: 48,
    lg: 36,
} as const;
